import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const planUpsellEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "plan-upsell" */
				'./src/ui'
			),
		{ entryFsSsrLiftImportToModule: false },
	),
	getPreloadProps: () => ({}),
});
